import React from 'react';
import { Route } from 'react-router-dom';
import Form from './modules/distributors/DistributorInvite';

export default [
  <Route exact path="/distributors/invite" component={Form} />
]
